import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const octen = defineConnector({
  identifier: "octen",
  name: "Octen",
  tagLine: "Real-time web search for AI",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://api\\.octen\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API key in the [Octen API platform](https://octen.ai/platform/api-keys).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.octen.ai/search",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "test", count: 1 }),
    }),
  },
});
